<h2 mat-dialog-title>{{data.title}}</h2>

<mat-dialog-content>{{data.description}}</mat-dialog-content>

<mat-dialog-actions>
    <button mat-button (click)="close()">OK</button>
</mat-dialog-actions>